import { useState } from "react";
import { motion } from "framer-motion";
import "./TrainingsSection.css";

const trainings = [
  { title: "Dizajn Grafik", icon: "✏️", desc: "Senior Graphic Design" },
  { title: "Foto & Video", icon: "📸", desc: "Foto Video" },
  { title: "Programim për Fëmijë", icon: "👦🏻", desc: "Kids Coding" },
  { title: "Frontend", icon: "🌐", desc: "Frontend Web" },
  { title: "Wordpress", icon: "📰", desc: "WP Website" },
  { title: "AI", icon: "🤖", desc: "Artificial Intelligence" },
];

export function TrainingsSection() {
  const [index, setIndex] = useState(0);
  const cardsToShow = 3; // gjithmonë 3

  // Shfaq 3 trajnime për faqe
  const showTrainings = trainings.slice(index, index + cardsToShow);

  const handleNext = () => {
    if (index + cardsToShow < trainings.length) {
      setIndex(index + cardsToShow);
    }
  };

  const handlePrev = () => {
    if (index - cardsToShow >= 0) {
      setIndex(index - cardsToShow);
    }
  };

  return (
    <section className="trainings-carousel-section">
      <h2 className="trainings-title">TRAJNIMET TONA</h2>
      <div className="carousel-nav">
        <button onClick={handlePrev} disabled={index === 0}>
          &#8592; Previous
        </button>
        <button
          onClick={handleNext}
          disabled={index + cardsToShow >= trainings.length}
        >
          Next &#8594;
        </button>
      </div>
      <div className="carousel-grid">
        {showTrainings.map((t, idx) => (
          <motion.div
            className="carousel-card"
            key={t.title}
            initial={{ opacity: 0, y: 30, scale: 0.97 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 12px 40px #1114",
              zIndex: 2,
            }}
            transition={{ duration: 0.34, type: "spring" }}
            viewport={{ once: true }}
          >
            <div className="carousel-icon">{t.icon}</div>
            <div className="carousel-title">{t.title}</div>
            <div className="carousel-desc">{t.desc}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
